import { styled } from 'styled-components';

import { TCardMode } from '@/modules/game/types';

interface IScEmptyGameCardContainerProps {
  mode: TCardMode;
}

export const ScEmptyGameCardContainer = styled.div<IScEmptyGameCardContainerProps>`
  display: flex;
  width: 100%;
  height: calc(100% - 41px);
  padding: 0px 12px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
  border-radius: 12px;

  &.black {
    background-color: ${({ theme }) => theme.blackColor};
  }

  &.dark {
    background-color: ${({ theme }) => theme.grayDarkColor};
  }

  &.light {
    background-color: ${({ theme }) => theme.gray1Color};
  }

  img {
    filter: ${({ mode }) =>
      `invert(${['dark', 'black'].includes(mode) ? 0 : 1})`};
  }
`;
